import _ from 'lodash'

import {
  ADD_PROFILE_SETTINGS_FIELD_ERROR,
  ADD_PROFILE_SETTINGS_FIELDS_ERRORS,
  CHANGE_PROFILE_SETTINGS_FORM_FIELD,
  CLEAR_PROFILE_SETTINGS_FIELD_ERROR,
  PREDEFINE_PROFILE_SETTINGS_FORM_DATA,
  PRISTINE_PROFILE_SETTINGS_FORM_DATA,
  RESET_PROFILE_SETTINGS_FORM_DATA,
} from './actions'

export const defaultFormData = (predefined = {}) =>
  _.merge(
    {
      email: '',
      name: '',
      officePhone: '',
      mobilePhone: '',
      jobTitle: '',
      grades: [],
      subjects: [],
    },
    _.pickBy(predefined, _.identity),
  )

export const initialState = () => ({
  data: defaultFormData(),
  errors: {},
})

export default function root(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_PROFILE_SETTINGS_FORM_FIELD:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_PROFILE_SETTINGS_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_PROFILE_SETTINGS_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case CLEAR_PROFILE_SETTINGS_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_PROFILE_SETTINGS_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(),
        errors: {},
      }

    case PREDEFINE_PROFILE_SETTINGS_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(action.payload),
        errors: {},
      }

    case PRISTINE_PROFILE_SETTINGS_FORM_DATA:
      return {
        ...state,
      }

    default:
      return state
  }
}
